/**
 * Mensagem de erro de uma chamada à API sem quebrar quando não há resposta
 * (queda de rede, CORS, erro do nginx etc.).
 */
export default function errorMessage(err) {
  const response = err && err.response;

  if (response && response.data && response.data.error) {
    return response.data.error;
  }

  if (response && response.status === 413) {
    return "Os dados enviados são grandes demais. Reduza o tamanho dos textos e tente novamente.";
  }

  return "Não foi possível se comunicar com o servidor. Verifique sua conexão e tente novamente.";
}
